import * as Promise from 'bluebird';

/**
 * Sets a classroom as archived by updating its state to '0' (in web version it does nothing)
 * @param id
 * @returns {function(*, *)}
 */
export let archiveClassroomPostAction = id => {
  return () => {
    return Promise.resolve();
  };
};
